<template>
  <div>
    <v-card v-if="entity">
      <v-card-text>
        <h2>Customer details</h2>
        <v-layout row>
          <v-flex xs12 md5>
            <strong>Customer id</strong>
          </v-flex>
          <v-flex xs12 md7>{{$route.params.id}}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md5>
            <strong>Customer name</strong>
          </v-flex>
          <v-flex xs12 md7>
            <EntityZ :entity="entity" />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text>
        <h2>Payment requests</h2>
        <table border="1">
          <tr>
            <th>Date requested</th>
            <th>File reference</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
          <tr v-for="request in modifiedRequests" :key="request.id">
            <td>
              <TimestampWithTooltip :timestamp="request.created" />
            </td>
            <td>
              <FileZ v-if="request.file" :file="request.file" />
              <span v-if="!request.file">{{request.fileid}}</span>
            </td>
            <td>{{request.amount | toCurrency}}</td>
            <td>
              <span style="color: red;" v-if="request.status == 0">Awaiting authorisation</span>
              <router-link
                v-if="request.status == 0"
                :to="{name:'request', params:{id:request.id}}"
              >Authorise</router-link>
              <span
                style="color: orange;"
                v-if="request.status == 1"
              >Payment authorised. Awaiting processing.</span>
              <span style="color: green;" v-if="request.status == 2">Success</span>
            </td>
          </tr>
        </table>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text>
        <h2>Make a payment request</h2>
        <p>Click the file below for which you wish to make a payment request (admin only)</p>
        <table border="1">
          <tr v-for="file in modifiedFiles" :key="file.id">
            <td>
              <FileZ :file="file" />
            </td>
            <td>
              <span v-if="file.category">{{file.category.name}}</span>
              <span v-if="!file.category">{{file.categoryId}}</span>
            </td>
            <td>
              <router-link :to="{name:'paymentFile', params:{id:file.id}}">Request payment</router-link>
            </td>
          </tr>
        </table>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text>
        <h2>Debit and Credit cards</h2>
        <table border="1">
          <tr>
            <th>Issuer</th>
            <th>Card number</th>
            <th>Expiry date</th>
            <th>Card type</th>
            <th>Date added</th>
            <!-- <th/> -->
          </tr>
          <tr v-for="card in modifiedCards" :key="card.id">
            <td>
              <span v-if="card.issuer">{{card.issuer.name}}</span>
              <span v-if="!card.issuer">{{card.issuerid}}</span>
            </td>
            <td>{{card.number}}</td>
            <td>{{card.expire}}</td>
            <td>
              <span v-if="card.cardType">{{card.cardType}}</span>
              <span v-if="!card.cardType">UNKNOWN</span>
            </td>
            <td>
              <TimestampWithTooltip :timestamp="card.created" />
            </td>
            <!-- <td><a @click="removeCard">Remove</a></td> -->
          </tr>
        </table>
        <router-link :to="{name:'card', params:{id:$route.params.id}}">Add card</router-link>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import FileZ from "@/components/link/FileZ";
import TimestampWithTooltip from "@/components/layout/widgets/TimestampWithTooltip";
import nbmlaw from "@/api/nbmlaw";
import { convertListOfObjectsToMap } from "@/util/helpers";
export default {
  name: "Customer",
  metaInfo() {
    return {
      title: "Customer",
      titleTemplate: "%s - Payments - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { EntityZ, FileZ, TimestampWithTooltip },
  computed: {
    modifiedRequests() {
      if (!this.requests) {
        return undefined;
      }
      const filesMap = this.modifiedFiles
        ? convertListOfObjectsToMap(this.modifiedFiles, "id")
        : undefined;
      return this.requests.map(r => {
        const file =
          filesMap && filesMap[r.fileid] ? filesMap[r.fileid] : undefined;
        return {
          ...r,
          file
        };
      });
    },
    modifiedFiles() {
      if (!this.files) {
        return undefined;
      }
      const categoriesMap = this.categories
        ? convertListOfObjectsToMap(this.categories, "id")
        : undefined;
      return this.files.map(f => {
        const category =
          categoriesMap && categoriesMap[f.categoryId]
            ? categoriesMap[f.categoryId]
            : undefined;
        return {
          ...f,
          category
        };
      });
    },
    modifiedCards() {
      if (!this.cards) {
        return undefined;
      }
      const issuersMap = this.issuers
        ? convertListOfObjectsToMap(this.issuers, "id")
        : undefined;
      return this.cards.map(c => {
        const issuer =
          issuersMap && issuersMap[c.issuerid]
            ? issuersMap[c.issuerid]
            : undefined;
        return {
          ...c,
          issuer
        };
      });
    }
  },
  data() {
    return {
      entity: null,
      files: null,
      cards: null,
      requests: null,
      issuers: null,
      categories: null
    };
  },
  methods: {
    fetchEntity() {
      nbmlaw
        .get(`/cors/admin/directory/entities/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.entity = response.data;
          if (!this.entity) {
            this.$router.push({
              name: "pageNotFound"
            });
          }
        })
        .catch(() => {});
    },
    fetchCards() {
      nbmlaw
        .get(`/cors/admin/directory/entities/${this.$route.params.id}/cards`)
        .then(response => {
          // console.log(response.data);
          this.cards = response.data;
        })
        .catch(() => {
          // console.log(error)
        });
    },
    fetchFilesRelated() {
      nbmlaw
        .get(
          `/cors/admin/directory/entities/${this.$route.params.id}/related/files`
        )
        .then(response => {
          // console.log(response.data);
          this.files = response.data;
        })
        .catch(() => {
          // console.log(error)
        });
    },
    fetchRequests() {
      nbmlaw
        .get(
          `/cors/admin/directory/entities/${this.$route.params.id}/related/files/paymentRequests`
        )
        .then(response => {
          // console.log(response.data);
          this.requests = response.data;
        })
        .catch(() => {
          // console.log(error)
        });
    },
    fetchIssuers() {
      nbmlaw
        .get(`/cors/admin/payment/issuers`)
        .then(response => {
          // console.log(response.data);
          this.issuers = response.data;
        })
        .catch(() => {});
    },
    fetchCategories() {
      nbmlaw
        .get(`/cors/admin/file/categories`)
        .then(response => {
          // console.log(response.data);
          this.categories = response.data;
        })
        .catch(() => {});
    },
    removeCard() {}
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchEntity();
        this.fetchCards();
        this.fetchFilesRelated();
        this.fetchRequests();
      }
    }
  },
  created() {
    this.fetchIssuers();
    this.fetchCategories();
  }
};
</script>
